import React from 'react';

export default function Notifications() {
  return (
    <svg
      width='96'
      height='56'
      viewBox='0 0 96 56'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g opacity='0.3'>
        <rect
          width='96'
          height='24'
          rx='4'
          fill='url(#paint0_linear_3080_25187)'
          fill-opacity='0.2'
        />
        <g clip-path='url(#clip0_3080_25187)'>
          <path
            d='M12.5 12L13.5 13L15.5 11M14 17C16.7615 17 19 14.7615 19 12C19 9.2385 16.7615 7 14 7C11.2385 7 9 9.2385 9 12C9 14.7615 11.2385 17 14 17Z'
            stroke='#A1A1AA'
            stroke-width='1.25'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </g>
        <rect
          x='28'
          y='9'
          width='60'
          height='6'
          rx='3'
          fill='url(#paint1_linear_3080_25187)'
          fill-opacity='0.2'
        />
      </g>
      <rect
        y='32'
        width='96'
        height='24'
        rx='4'
        fill='url(#paint2_linear_3080_25187)'
        fill-opacity='0.2'
      />
      <g clip-path='url(#clip1_3080_25187)'>
        <path
          d='M12.5 44L13.5 45L15.5 43M14 49C16.7615 49 19 46.7615 19 44C19 41.2385 16.7615 39 14 39C11.2385 39 9 41.2385 9 44C9 46.7615 11.2385 49 14 49Z'
          stroke='#A1A1AA'
          stroke-width='1.25'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </g>
      <rect
        x='28'
        y='41'
        width='60'
        height='6'
        rx='3'
        fill='url(#paint3_linear_3080_25187)'
        fill-opacity='0.2'
      />
      <defs>
        <linearGradient
          id='paint0_linear_3080_25187'
          x1='0'
          y1='12'
          x2='96'
          y2='12'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_3080_25187'
          x1='28'
          y1='12'
          x2='88'
          y2='12'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_3080_25187'
          x1='0'
          y1='44'
          x2='96'
          y2='44'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_3080_25187'
          x1='28'
          y1='44'
          x2='88'
          y2='44'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0' />
        </linearGradient>
        <clipPath id='clip0_3080_25187'>
          <rect
            width='12'
            height='12'
            fill='white'
            transform='translate(8 6)'
          />
        </clipPath>
        <clipPath id='clip1_3080_25187'>
          <rect
            width='12'
            height='12'
            fill='white'
            transform='translate(8 38)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
